import { useContext, useMemo } from 'react';
import { ConversionDataContext } from './conversion-data-context';

export function useIsUetTag() {
  const { tagContext } = useContext(ConversionDataContext);
  const { data: tag } = tagContext || {};

  const isUetTag = useMemo(() => tag && tag.type === 'UET', [tag]);

  return isUetTag;
}
